import React from 'react'
import { SuccessStyles } from '../Style'
import { Img } from 'styles/GlobalStyle'
import { SuccessMic_Go } from 'assets'
import { AnimatePresence } from "motion/react"
import { check_mic_success } from 'introductions'
import { _check_mic_success } from 'introductions/highGrades'
import ReactPlayer from 'react-player';
import * as motion from "motion/react-client"

const Success = (props) => {
    const { isMaleGender, onTestPassed, isHighGrade, isTeacherCheck } = props

    if (isTeacherCheck) {
        return (
            <AnimatePresence>
                <motion.div
                    exit={{ opacity: 0 }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.7 }}
                    key="success-teacher"
                >
                    <SuccessStyles sx={{ rowGap: '16px', justifyContent: 'flex-start' }}>
                        <div className='text-group'>
                            <div className='text1'>{"מצוין!"}</div>
                            <div className='text2'>
                                {"ההקלטה נשמעת ברור!"}
                                <br />
                                {"אפשר להתחיל את המבדקים"}
                            </div>
                        </div>
                        <Img className="cartoon-flow" src={SuccessMic_Go} />
                    </SuccessStyles>
                </motion.div>
            </AnimatePresence>
        )
    }

    return (
        <>
            <motion.div
                exit={{ opacity: 0 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.7 }}
                key="error-mic"
            >
                <SuccessStyles>
                    <div>
                        <div className='text1'>
                            {
                                isMaleGender ?
                                    "יֹפִי, אֲנִי שׁוֹמֵעַ אוֹתְךָ!" : "יֹפִי, אֲנִי שׁוֹמֵעַ אוֹתָךְ!"
                            }
                        </div>
                        <div className='text2'>{"אֶפְשָׁר לְהַתְחִיל!"}</div>
                    </div>
                    <div className='side-cartoon'>
                        <Img src={SuccessMic_Go} />
                    </div>
                </SuccessStyles>
            </motion.div>
            <ReactPlayer
                playing={true}
                url={isHighGrade ? _check_mic_success : check_mic_success}
                controls={true}
                width='0px' height='0px'
                onEnded={onTestPassed}
            />
        </>
    )
}

export default Success